import { useEffect } from "react";
import axios from "axios";
function Login() {
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("access_token")}`;
  useEffect(() => {
    (async () => {
      try {
        await axios.post(
          process.env.API_URL + "/users/logout/",
          {
            refresh_token: localStorage.getItem("refresh_token"),
            headers: { "Content-Type": "application/json" },
          }
        );
        localStorage.clear();
        axios.defaults.headers.common["Authorization"] = null;
        window.location.href = "/login";
      } catch (e) {
        console.log("logout not working", e);
      }
    })();
  }, []);
  return <div></div>;
}

export default Login;
